import { Component, OnInit, Renderer2  } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {

  constructor(private renderer: Renderer2) { }

  ngOnInit() {
    this.renderer.addClass(document.body, 'backgroundLanding')
    this.renderer.removeClass(document.body, 'backgroundHome');
    this.renderer.addClass(document.getElementById("navbarSupportedContent"), 'navbarWhite')
    this.renderer.removeClass(document.getElementById("navbarSupportedContent"), 'navbarLogoWine')
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'backgroundLanding');
    this.renderer.removeClass(document.getElementById("navbarSupportedContent"), 'navbarWhite')
    this.renderer.addClass(document.getElementById("navbarSupportedContent"), 'navbarLogoWine')
  }

}
